module.exports = __webpack_public_path__ + "static/JD-c2fc36f49792a2bfde7edcad61ee6bff.jpg";